// extracted by mini-css-extract-plugin
export var container = "_8i-0";
export var error = "_8i-9";
export var label = "_8i-5";
export var light = "_8i-6";
export var md = "_8i-3";
export var sm = "_8i-2";
export var thin = "_8i-8";
export var thinBold = "_8i-7";
export var vertical = "_8i-4";
export var xs = "_8i-1";